module.exports = __webpack_public_path__ + "static/media/hp_1.bdc12212.svg";